import type { PlayerPriceChange } from '@api-service/players';

export type PriceChangeDirection = 'rise' | 'fall' | 'none';

const LOCKED_LABEL = 'Locked';

/**
 * Progress is signed: a positive value means the price is climbing towards a
 * rise, a negative value means it is falling towards a drop, and zero means no
 * movement is predicted. Mirrors the treatment on the price-rises page table.
 */
export const getPriceChangeDirection = (
  progress: number
): PriceChangeDirection => {
  if (progress === 0) return 'none';
  return progress > 0 ? 'rise' : 'fall';
};

/** Falls back to "Locked" when the estimated change time is not yet known. */
export const getPriceChangeTimeLabel = (
  estimatedChangeTime: PlayerPriceChange['estimatedChangeTime']
): string => estimatedChangeTime ?? LOCKED_LABEL;
